import * as tslib_1 from "tslib";
import { PromoCode } from '../models/promo-code.edum';
var PromoService = /** @class */ (function () {
    function PromoService() {
        this.promos = [];
        this.fillPromos();
    }
    PromoService.prototype.fillPromos = function () {
        this.addPromo({
            codigo: PromoCode.PROMO_OFF,
            valor: 'OFF',
            etiqueta: 'OFF',
            isPromo: true,
            imageName: 'amount-off-wt.png',
            prefix: 'US$',
            suffix: ' OFF'
        });
        this.addPromo({
            codigo: PromoCode.PROMO_PORCENT_OFF,
            valor: 'OFF',
            etiqueta: '% OFF',
            isPromo: true,
            imageName: 'percentage-off-wt.png',
            suffix: '% OFF'
        });
        this.addPromo({
            codigo: PromoCode.PROMO_2_X_1,
            valor: '2 X 1',
            etiqueta: '2 X 1',
            isPromo: true,
            imageName: 'two-by-one-wt.png'
        });
        this.addPromo({
            codigo: PromoCode.PROMO_RAC,
            valor: 'NO PROMO',
            etiqueta: 'Regular Rate',
            isPromo: false,
        });
        this.addPromo({
            codigo: PromoCode.PROMO_NET,
            valor: 'NETA',
            etiqueta: '1 Net',
            isPromo: true,
            alternateText: 'Super Promo',
            imageName: 'amount-off-wt.png'
        });
        this.addPromo({
            codigo: PromoCode.PROMO_SUPER_PROMO,
            valor: 'NETA',
            etiqueta: '1 Net',
            isPromo: true,
            alternateText: 'Super Promo',
            imageName: 'amount-off-wt.png'
        });
    };
    PromoService.prototype.addPromo = function (promo) {
        this.promos.push(promo);
    };
    PromoService.prototype.getPromos = function () {
        return this.promos;
    };
    PromoService.prototype.getPromoById = function (promoId) {
        var e_1, _a;
        try {
            for (var _b = tslib_1.__values(this.getPromos()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var promo = _c.value;
                if (promo.codigo === promoId) {
                    return promo;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        console.error('promo.service.getPromoById() > The provided promo code was not found on the service');
        return null;
    };
    PromoService.prototype.isPromo = function (promo) {
        var servicePromo = this.getPromoById(promo.codigo);
        if (servicePromo) {
            return servicePromo.isPromo;
        }
        else {
            console.error('promo.service.isPromo() > There was a problem with the provided Promo object');
            return false;
        }
    };
    PromoService.prototype.getPromoText = function (promoId, value) {
        var promoText = '';
        var promo = this.getPromoById(promoId);
        if (!promo) {
            console.error('PromoService.getPromoText() > The requested promo could not have been found ');
            return null;
        }
        promoText += promo.prefix || '';
        promoText += promo.codigo === PromoCode.PROMO_2_X_1 ? promo.alternateText || promo.valor : promo.alternateText ||
            (value < 1 ? value * 100 : value);
        promoText += promo.suffix || '';
        return promoText;
    };
    PromoService.prototype.getPromoImg = function (promoId) {
        var promo = this.getPromoById(promoId);
        if (!promo) {
            console.error('PromoService.getPromoImg() > Could not find the promo with the id ' + promoId);
            return '';
        }
        return promo.imageName || '';
    };
    return PromoService;
}());
export { PromoService };
